import { ISelectedValuesMap } from '~/src/dash/components/endpoint-builder';
import { IQueryParam } from '~/src/dash/types/endpoint-query-params';
import { IMenuList } from '~/src/dash/types/menuList';

export const ANY = 'any';
export const ALL = 'all';

// setting the value of a changeable param value
export const setParamValues = (
  parentParam: IQueryParam,
  param: IQueryParam,
  idx: number,
  paramsObject: { [k: string]: any },
  selectDependencies: { [k: string]: IQueryParam[] },
): string => {
  let paramValue: string = '';
  if (paramsObject.hasOwnProperty(param.paramName)) {
    selectDependencies[parentParam.paramName][idx].paramValue = paramsObject[param.paramName];
    paramValue = paramsObject[param.paramName];
  }
  return paramValue;
};

// for passing URL type string to onEndpointParamsListChange
export const selectedValueMapToString = (selectedValuesMap: ISelectedValuesMap) => {
  return Object.entries(selectedValuesMap)
    .map(([key, value]) => {
      return `${key.replace(' (invisible)', '')}=${value}`;
    })
    .join('&');
};

export const queryParamToIMenuList = (
  params: IQueryParam[],
  selectedValues: ISelectedValuesMap,
): IMenuList => {
  const out = {} as IMenuList;
  params.forEach(({ text, paramName, paramValue }) => {
    out[paramName] = {
      ID: paramName,
      selected: !!selectedValues[paramName],
      title: text || '',
      description: paramValue, // Used to hold the macro value
    };
  });
  return out;
};

export const updateSelectedParams = (
  newParams: IMenuList,
  endpointParamList: ISelectedValuesMap,
) => {
  Object.keys(newParams).forEach((key) => {
    if (newParams[key] && newParams[key].selected) {
      // If the param is selected, add it
      if (newParams[key].description) {
        endpointParamList[key] = newParams[key].description || '';
      } else {
        endpointParamList[key] = newParams[key].title;
      }
    } else if (newParams[key] && !newParams[key].selected) {
      // If the key was deselected, remove it
      delete endpointParamList[key];
    }
  });
};
